import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import api from "api/axios";

function OumrahDocumentsTypes() {
  const [types, setTypes] = useState([]);
  const [nouveau, setNouveau] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchTypes = async () => {
    try {
      const res = await api.get("/oumrah/documents/types");
      setTypes(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => { fetchTypes(); }, []);

  const ajouter = async () => {
    if (!nouveau.trim()) return;
    setLoading(true);
    try {
      await api.post("/oumrah/documents/types", { libelle: nouveau.trim(), obligatoire: true });
      setNouveau("");
      fetchTypes();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    } finally {
      setLoading(false);
    }
  };

  const modifier = async (id, champ, valeur) => {
    try {
      await api.put("/oumrah/documents/types/" + id, { [champ]: valeur });
      fetchTypes();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    }
  };

  const supprimer = async (id) => {
    if (!window.confirm("Supprimer ce document ? Le suivi associé sera perdu.")) return;
    try {
      await api.delete("/oumrah/documents/types/" + id);
      fetchTypes();
    } catch (err) {
      alert(err.response?.data?.message || "Erreur");
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={9} lg={7}>
            <Card>
              <MDBox mx={2} mt={-3} py={2} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">Documents administratifs requis</MDTypography>
              </MDBox>
              <MDBox p={3}>
                <MDTypography variant="caption" color="text" display="block" mb={2}>
                  Cochez « Obligatoire » pour les documents qui bloquent la confirmation d'une inscription tant qu'ils ne sont pas fournis.
                </MDTypography>

                {/* Ajout d'un document */}
                <MDBox display="flex" gap={1} mb={3}>
                  <TextField
                    label="Nouveau document"
                    size="small"
                    fullWidth
                    value={nouveau}
                    onChange={(e) => setNouveau(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") ajouter(); }}
                  />
                  <MDButton color="info" onClick={ajouter} disabled={loading || !nouveau.trim()}>
                    <Icon>add</Icon>&nbsp;Ajouter
                  </MDButton>
                </MDBox>

                <Divider />

                {/* Liste des documents */}
                {types.length === 0 && (
                  <MDTypography variant="body2" color="text" textAlign="center" py={2}>
                    Aucun document défini.
                  </MDTypography>
                )}
                {types.map((t) => (
                  <MDBox
                    key={t.id}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    py={1.5}
                    sx={{ borderBottom: "1px solid #f0f0f0", opacity: t.actif ? 1 : 0.5 }}
                  >
                    <MDBox flex={1}>
                      <TextField
                        variant="standard"
                        defaultValue={t.libelle}
                        onBlur={(e) => { if (e.target.value !== t.libelle) modifier(t.id, "libelle", e.target.value); }}
                        sx={{ minWidth: 200 }}
                      />
                    </MDBox>
                    <MDBox display="flex" alignItems="center" gap={2}>
                      <MDBox display="flex" alignItems="center">
                        <Switch
                          checked={!!t.obligatoire}
                          onChange={(e) => modifier(t.id, "obligatoire", e.target.checked)}
                        />
                        <MDTypography variant="caption" color={t.obligatoire ? "error" : "text"} fontWeight={t.obligatoire ? "bold" : "regular"}>
                          Obligatoire
                        </MDTypography>
                      </MDBox>
                      <MDBox display="flex" alignItems="center">
                        <Switch
                          checked={!!t.actif}
                          onChange={(e) => modifier(t.id, "actif", e.target.checked)}
                        />
                        <MDTypography variant="caption" color="text">Actif</MDTypography>
                      </MDBox>
                      <IconButton color="error" onClick={() => supprimer(t.id)} size="small">
                        <Icon>delete</Icon>
                      </IconButton>
                    </MDBox>
                  </MDBox>
                ))}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default OumrahDocumentsTypes;
